import ApiService from '@/api';
import {
  GetByOwnerTasksRequestModel,
  GetByParentTasksRequestModel,
  GetByPerformerTasksRequestModel,
  GetByPriorityTasksRequestModel,
  GetByStatusTasksRequestModel,
  GetByTagTasksRequestModel,
  GetByTypeTasksRequestModel,
  GetGlobalStatusesResponse,
  GroupedTaskItemModel,
  GroupedTaskRequestModel,
  PageRequestModel,
  PageResponseModel,
  ResponseModel,
  TaskModel,
  TaskModelDetail,
  TaskMoveQueueRequestModel,
  TaskPersonModel,
  TaskPriorityModel,
  TaskQueueModel,
  TaskStatusModel,
  TaskUpdatePriorityModel,
  TaskUpdateStatusModel,
  TaskUpdateTypeModel,
} from '../models';
import {
  mapGetByOwnerTaskListRequest,
  mapGetByOwnerTaskListResponse,
  mapGetByParentTaskListRequest,
  mapGetByParentTaskListResponse,
  mapGetByPerformerTaskListRequest,
  mapGetByPerformerTaskListResponse,
  mapGetByPriorityTaskListRequest,
  mapGetByPriorityTaskListResponse,
  mapGetByStatusTaskListRequest,
  mapGetByStatusTaskListResponse,
  mapGetByTagTaskListRequest,
  mapGetByTagTaskListResponse,
  mapGetByTypeTaskListRequest,
  mapGetByTypeTaskListResponse,
  mapGetGroupedByOwnerTaskListRequest,
  mapGetGroupedByOwnerTaskListResponse,
  mapGetGroupedByPerformerTaskListRequest,
  mapGetGroupedByPerformerTaskListResponse,
  mapGetGroupedByPriorityTaskListRequest,
  mapGetGroupedByPriorityTaskListResponse,
  mapGetGroupedByStatusTaskListRequest,
  mapGetGroupedByStatusTaskListResponse,
  mapGetGroupedByTagTaskListRequest,
  mapGetGroupedByTagTaskListResponse,
  mapGetGroupedByTypeTaskListRequest,
  mapGetGroupedByTypeTaskListResponse,
  mapGetWithoutGroupingTaskListRequest,
  mapGetWithoutGroupingTaskListResponse,
  mapTaskMoveQueueRequestModel,
  mapUpdatePriorityRequest,
  mapUpdateStatusRequest,
  mapUpdateTypeRequest,
} from './AdapterServiceMappers';
import { TasksKanbanGrouppingTypeEnum } from '../enums';
import RemoveSubtaskRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/RemoveSubtaskRequest';
import AttachSubtaskRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/AttachSubtaskRequest';
import { TaskParameterModel } from '@/components/task-parameter';
import UpdateQueueTaskStatusRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/status/UpdateQueueTaskStatusRequest';
import { SendErrorNotification } from '@/components/task-parameters-form/adapter-service/functions';
import UpdateQueueTaskStatusRequestItem from '@/api/Main/dataSource/api/projects/task/i-service/models/status/UpdateQueueTaskStatusRequestItem';
import { Events } from '@/api/Main/dataSource/api/plugins/events';
import GetTaskListByTreeShortRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetTaskListByTreeShortRequest';
import GetTaskListByTreeShortResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskListByTreeShortResponse';
import {
  DifficultyModel,
  PaginationResponseModel,
  TagModel,
  TypeModel,
} from '@/components/task-forms/models';
import { ProjectModel } from '@/models';
import ProjectSearchRequest from '@/api/Main/dataSource/api/projects/base/i-service/models/ProjectSearchRequest';
import EnumProjectType from '@/api/Main/dataSource/api/projects/base/entities/enums/EnumProjectType';
import { NamespaceModel } from '@/pages/project-namespaces-page/components/namespace-card/models';
import { mapGetNamespacesRequest } from '@/pages/project-namespaces-page/adapter/AdapterServiceMappers';
import { mapGetNamespacesResponse } from '@/components/tasks-kanban/adapter/AdapterServiceMappers';
import { QueueModel } from '@/pages/namespace-queues-page/models';
import {
  mapGetListRequest,
  mapGetListResponse,
} from '@/pages/namespace-queues-page/adapter/AdapterServiceMappers';
import GetDifficultyListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/request/GetDifficultyListRequest';
import GetDifficultyListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/response/GetDifficultyListResponse';
import { SendRequestModel } from '@/api/Main/dataSource/api/plugins/models/SendRequestModel';
import WsResponseModelT from '@/api/Main/dataSource/api/schema-builder/server/models/WsResponseModelT';
import { WebApiService } from '@/api/Main/dataSource/api/plugins/webApiService';
import {
  mapCreateTaskRequest,
  mapGetDifficultyListResponse,
  mapGetTagsRequest,
  mapGetTagsResponse,
  mapGetTypesResponse,
} from '@/components/task-forms/components/task-drawer/adapter/AdapterServiceMappers';
import GetDifficultyListItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/response/GetDifficultyListItem';

import { useRoute } from 'vue-router';
import GetQueueTaskEmployeeListDetailRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/GetQueueTaskEmployeeListDetailRequest';
import { EmployeeAccessModel } from '@/components/edit-queue-modal/models';
import { mapGetUsersAccessResponse } from '@/components/edit-queue-modal/adapter-service/adapter-service.mappers';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-components';
import CheckProjectAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/CheckProjectAdminRequest';
import CheckProjectAdminResponse from '@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/CheckProjectAdminResponse';
import CheckNamespaceAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/CheckNamespaceAdminRequest';
import DifficultyLevelTaskModel from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/DifficultyLevelTaskModel';
import GetStatusesListDetailResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/status/GetStatusesListDetailResponse';
import GetPrioritiesListDetailResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/type-priority/GetPrioritiesListDetailResponse';
import GetDifficultyListDetailResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/response/GetDifficultyListDetailResponse';
import GetListStatusResponseItem from '@/api/Main/dataSource/api/projects/task/i-service/models/status/GetListStatusResponseItem';
import TaskPriorityResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/type-priority/TaskPriorityResponse';
import GetListStatusOrganizationItem from '@/api/Main/dataSource/api/projects/task/i-service/models/status/GetListStatusOrganizationItem';
import ProjectQueueTaskListResponse from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListResponse';
import SubscribeToQueueTasksRequest from '../models/SubscribeToQueueTasksRequest';
import GetListTaskTypeRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task-type/request/GetListTaskTypeRequest';
import {
  mapGetTaskDetailRequest,
  mapGetTaskDetailResponse,
} from '@/components/task-forms/components/task-detail/adapter/AdapterServiceMappers';
import { CreateTaskModel } from '@/components/task-forms/components/task-drawer/models';
import PageResponse from '@/pages/tasks-order-pages/models/PageResponseModel';
import ProjectSearchRequestModel from '@/components/sidebar/models/ProjectSearchRequestModel';
import {
  BaseProjectResponse,
  BaseProjectSearchResponse,
} from '../components/options-filter/components/filter-parameter/adapter/models';
import GetPerformersTaskRequest from '../models/GetPerformersTaskRequestModel';
import GetPerformersTaskResponse from '../models/GetPerformersTaskResponseModel';
import { AddTaskZmkForUserRequest } from '@/pages/tasks-order-pages/models';
import GetPerformersTaskRequestModel from '../models/GetPerformersTaskRequestModel';
import GetPerformersTaskResponseModel from '../models/GetPerformersTaskResponseModel';
import GetNamespaceByIdResponse from '@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdResponse';
import GetListByProjectIdResponseItem from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/GetListByProjectIdResponseItem';
import GetAccessCurrentUserInQueueTaskByIdRequestModel from '../models/GetAccessCurrentUserInQueueTaskByIdRequestModel';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

export class QueueTaskNamespaceModel {
  Name!: string;
  Id!: string;
  ColorId!: string;
  Color!: string;
  IconId!: string;
  IconUrl!: string;
  constructor(obj?: Partial<QueueTaskNamespaceModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class ProjectNamespaceListItem {
  Id!: string;
  Name!: string;
  IconId!: string;
  IconUrl!: string;
  ColorId!: string;
  Color!: string;
  TaskCount!: number;
  IsAdmin: boolean = false;
  constructor(obj?: Partial<ProjectNamespaceListItem>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class ProjectNamespaceListResponse {
  Items!: Array<ProjectNamespaceListItem>;
  Page!: PageResponse;
  constructor(obj?: Partial<ProjectNamespaceListResponse>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
export class GetPrioritiesListDetailQueueItem {
  QueueTaskId!: string;
  QueueTaskName!: string;
  PriorityId!: number;
  PriorityName!: string;
  PriorityColor!: string;
  PriorityIsDefault: boolean = false;
  PriorityNumber!: number;
  constructor(obj?: Partial<GetPrioritiesListDetailQueueItem>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class GetDifficultyListDetailRequest {
  Search!: string;
  Page!: PageRequest;
  ProjectId?: number;
  NamespaceId?: string;
  NamespaceIds!: Array<string>;
  OrderByName?: boolean = false;
  constructor(obj?: Partial<GetDifficultyListDetailRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class GetDifficultyListItemDetail {
  NamespaceId!: string;
  NamespaceName!: string;
  NamespaceColorId!: string;
  NamespaceColor!: string;
  NamespaceIconId!: string;
  NamespaceIconUrl!: string;
  DifficultyId!: string;
  DifficultyName!: string;
  DifficultyColor!: string;
  constructor(obj?: Partial<GetDifficultyListItemDetail>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export default class ProjectNamespaceListRequest {
  Search!: string;
  ProjectId!: number;
  CheckInPerformer: boolean = false;
  Page!: PageRequest;
  OnlyUserIsPerformer: boolean = false;
  ShowOnlyCurrentIsAdmin: boolean = false;
  constructor(obj?: Partial<ProjectNamespaceListRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class GetStatusesListDetailRequest {
  Search!: string;
  Page!: PageRequest;
  QueueTaskId?: string;
  QueueTaskIds!: Array<string>;
  NamespaceId?: string;
  NamespaceIds!: Array<string>;
  GroupId?: number;
  ProjectId?: number;
  OrderByName?: boolean = false;
  constructor(obj?: Partial<GetStatusesListDetailRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class ProjectQueueTaskListItem {
  Id!: string | number;
  Name!: string;
  TaskCount?: number;
  IsConfigured?: boolean = false;
  Number?: number;
  NamespaceId?: string;
  constructor(obj?: Partial<ProjectQueueTaskListItem>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class ProjectQueueTaskListRequest {
  Search!: string;
  GroupId?: number;
  NamespacesId!: Array<string>;
  QueueTaskId?: string;
  OnlyPerformerCurrentUser: boolean = false;
  PerformerId?: number;
  Page!: PageRequest;
  OrderByName?: boolean = false;
  constructor(obj?: Partial<ProjectQueueTaskListRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class GetStatusesListDetailItem {
  QueueTaskId!: string;
  QueueTaskName!: string;
  StatusId!: number;
  StatusName!: string;
  StatusColor!: string;
  StatusIsDefault: boolean = false;
  OrganizationGlobalStatus!: GetListStatusOrganizationItem;
  constructor(obj?: Partial<GetStatusesListDetailItem>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class GetPrioritiesListDetailRequest {
  Search!: string;
  Page!: PageRequest;
  QueueTaskId?: string;
  QueueTaskIds!: Array<string>;
  NamespaceId?: string;
  NamespaceIds!: Array<string>;
  GroupId?: number;
  ProjectId?: number;
  OrderByName?: boolean = false;
  constructor(obj?: Partial<GetPrioritiesListDetailRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class PageRequest {
  Skip?: number;
  Take?: number;
  constructor(obj?: Partial<PageRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class TaskKanbanAdapterService {
  private readonly api = new ApiService();

  private url?: string;
  private cookieName: string;
  private appWebSettingsPath?: string;
  private apiUrlProperty?: string;

  constructor(
    url?: string,
    cookieName?: string,
    appWebSettingsPath?: string,
    apiUrlProperty?: string,
  ) {
    this.url = url;
    this.cookieName = cookieName ?? 'Auth-Token';
    this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join('/');
    this.apiUrlProperty = apiUrlProperty;
  }

  UpdateQueueTaskStatusEvent = new Events<ResponseModel<any>>();
  // UpdateQueueTaskPriorityEvent = new Events<ResponseModel<any>>();
  // UpdateProjectTagsEvent = new Events<ResponseModel<any>>();
  // UpsertTypeToNamespaceIdEvent = new Events<ResponseModel<any>>();
  // UpsertDifficultyToNamespaceIdEvent = new Events<ResponseModel<any>>();

  /**
   * * Метод для переноса задачи в очереди
   */
  taskMoveInQueueAsync(request: TaskMoveQueueRequestModel): Promise<ResponseModel<Boolean>> {
    return new Promise<ResponseModel<Boolean>>(async (resolve) => {
      const result = new ResponseModel<Boolean>();

      await this.api.Main.ProjectTaskSaveService.taskMoveInQueueAsync(
        mapTaskMoveQueueRequestModel(request),
      )
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR taskMoveInQueueAsync', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получить список неймспейсов
   * @param projectId ID проекта
   * @returns
   */
  getNamespaces(projectId: number) {
    return new Promise<ResponseModel<Array<NamespaceModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<NamespaceModel>>();

      await this.api.Main.ProjectNamespaceService.getListAsync(mapGetNamespacesRequest(projectId))
        .then((resp) => {
          result.Value = mapGetNamespacesResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение доступов по текущему пользователю в очереди задач по идентификатору
   */
  async getAccessCurrentUserInQueueTaskById(
    request: GetAccessCurrentUserInQueueTaskByIdRequestModel,
  ): Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>> {
    return new Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>>(
      async (resolve) => {
        const result = new ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>();
        try {
          const response =
            await this.api.Main.QueueTaskAdminRoleService.getAccessCurrentUserInQueueTaskByIdAsync(
              request,
            );
          result.Value = response;
          resolve(result);
        } catch (e) {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR', e);
          return result;
        }
      },
    );
  }
  /**Получить список глобальных статусов */
  async getGlobalStatuses(): Promise<ResponseModel<GetGlobalStatusesResponse>> {
    const result = new ResponseModel<GetGlobalStatusesResponse>();

    try {
      const response = await this.api.Main.TaskStatusListService.getGlobalStatusesAsync();
      result.Value = response;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      console.error('ERROR getOwnedUsersAsync', e);
    }

    return result;
  }
  /**
   * * Метод для получения исполнителей по задаче(с проверкой на доступ к очереди)
   */
  async getPerformersTaskAsync(req: GetPerformersTaskRequestModel) {
    return new Promise<ResponseModel<GetPerformersTaskResponseModel>>(async (resolve) => {
      const result = new ResponseModel<GetPerformersTaskResponse>();

      await this.api.Main.ProjectTaskGetService.getPerformersTaskAsync(req)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
  /**Добавление задачи в очередность */
  addTaskZmkForUserAsync(request: AddTaskZmkForUserRequest): Promise<ResponseModel<Boolean>> {
    return new Promise<ResponseModel<Boolean>>(async (resolve) => {
      let result = new ResponseModel<Boolean>();

      await this.api.Main.TaskOrderSaveService.addTaskZmkForUserAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR addTaskZmkForUserAsync', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение списка статусов с детальной информацией и фильтрами
   */
  async getStatusesListDetail(request: GetStatusesListDetailRequest) {
    return new Promise<ResponseModel<GetStatusesListDetailResponse>>(async (resolve) => {
      const result = new ResponseModel<GetStatusesListDetailResponse>();

      await this.api.Main.TaskStatusListService.getStatusesListDetailAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение списка приоритетов с детальной информацией и фильтрами
   */
  async getPrioritiesListDetail(request: GetPrioritiesListDetailRequest) {
    return new Promise<ResponseModel<GetPrioritiesListDetailResponse>>(async (resolve) => {
      const result = new ResponseModel<GetPrioritiesListDetailResponse>();

      await this.api.Main.TaskPriorityGetService.getPrioritiesListDetailAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }

  /**Подписаться на события очереди */
  async subscribeToQueueEvent(request: SubscribeToQueueTasksRequest) {
    await this.api.Main.ProjectTaskSaveService.subscribeToQueueTasksAsync(request);
  }
  /**Подписаться на события очереди */
  async udSubscribeToQueueEvent(request: SubscribeToQueueTasksRequest) {
    await this.api.Main.ProjectTaskSaveService.unSubscribeFromQueueTasksAsync(request);
  }

  /**
   * * Создание задачи
   * @param request Запрос
   * @returns
   */
  createTask(request: CreateTaskModel) {
    return new Promise<ResponseModel<number>>(async (resolve) => {
      const result = new ResponseModel<number>();

      await this.api.Main.ProjectTaskSaveService.taskCreateAsync(mapCreateTaskRequest(request))
        .then((resp) => {
          result.Value = resp.Id;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR createTask', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение детального списка сложности задач
   */
  async getDifficultyListDetail(request: GetDifficultyListDetailRequest) {
    return new Promise<ResponseModel<GetDifficultyListDetailResponse>>(async (resolve) => {
      const result = new ResponseModel<GetDifficultyListDetailResponse>();
      await this.api.Main.TaskDifficultyListService.getDifficultyListDetailAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }

  /**Получение детальной информации о списке сотрудников рабочей области с доступами по очереди задач */
  async getQueueUsersRoles(
    req: GetQueueTaskEmployeeListDetailRequest,
  ): Promise<ResponseModel<EmployeeAccessModel[]>> {
    const result = new ResponseModel<EmployeeAccessModel[]>();

    try {
      const response =
        await this.api.Main.QueueTaskAdminRoleService.getQueueTaskEmployeeListDetailAsync(req);
      result.Value = mapGetUsersAccessResponse(response);
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR getOwnedUsersAsync', e);
    }

    return result;
  }

  async isProjectAdmin(req: CheckProjectAdminRequest): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();

    try {
      const response = await this.api.Main.ProjectAdminRoleService.checkProjectAdminAsync(req);
      result.Value = response.IsProjectAdmin;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR checkProjectAdminAsync', e);
    }

    return result;
  }

  async isNamespaceAdmin(req: CheckNamespaceAdminRequest): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();
    try {
      const response = await this.api.Main.NamespaceAdminRoleService.checkNamespaceAdminAsync(req);
      result.Value = response.IsNamespaceAdmin;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR checkNamespaceAdminAsync', e);
    }

    return result;
  }

  getListNamespaceAsync(request: ProjectNamespaceListRequest) {
    return new Promise<ResponseModel<ProjectNamespaceListResponse>>(async (resolve) => {
      const result = new ResponseModel<ProjectNamespaceListResponse>();

      await this.api.Main.ProjectNamespaceService.getListAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }

  SetList(
    entityId: string,
    parameters: TaskParameterModel[],
  ): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TaskStatusSaveService.updateQueueTaskStatusAsync(
        new UpdateQueueTaskStatusRequest({
          QueueTaskId: entityId,
          Statuses: parameters.map(
            (x) =>
              new UpdateQueueTaskStatusRequestItem({
                StatusId: x.Id as number,
                Name: x.Name,
                Color: x.Color,
                IsDefault: x.IsDefault,
              }),
          ),
        }),
      )
        .then((response) => {
          result.Value = response.Items.map(
            (p) =>
              new TaskParameterModel({
                Id: p.StatusId,
                Name: p.Name,
                Color: p.Color,
                IsDefault: p.IsDefault,
                InUse: (p as any).InUse,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error('ERROR updateQueueTaskEmployeeRoleList', e);
          return resolve(result);
        });
    });
  }
  /**
   * Получение информации об очереди
   * @param queueId
   * @returns
   */
  async getQueue(
    request: ProjectQueueTaskListRequest,
  ): Promise<ResponseModel<ProjectQueueTaskListResponse>> {
    const result = new ResponseModel<ProjectQueueTaskListResponse>();
    try {
      const res = await this.api.Main.ProjectQueueTaskService.getListAsync(request);
      result.Value = res;
      result.IsSuccess = true;
      return result;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      console.error('ERROR getQueue', e);
      return result;
    }
  }

  /**
   * Получение информации об очереди
   * @param queueId
   * @returns
   */
  async getQueueDetail(queueId: string): Promise<ResponseModel<ProjectQueueTaskListItem>> {
    const req = new ProjectQueueTaskListRequest({
      QueueTaskId: queueId,
      NamespacesId: [],
      Page: new PageRequest({ Skip: 0, Take: 1000 }),
    });
    const result = new ResponseModel<ProjectQueueTaskListItem>();
    try {
      const res = await this.api.Main.ProjectQueueTaskService.getListAsync(req);
      const result = new ResponseModel<ProjectQueueTaskListItem>();
      result.Value = res?.Items[0] || null;
      result.IsSuccess = true;
      return result;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      console.error('ERROR getQueue', e);
      return result;
    }
  }

  /**
   * * Получить список очередей
   * @param namespaceId ID неймспейса
   * @returns
   */
  getQueueList(namespaceId: string, OnlyPerformerCurrentUser: boolean) {
    return new Promise<ResponseModel<Array<TaskQueueModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<TaskQueueModel>>();

      await this.api.Main.ProjectQueueTaskService.getListAsync(
        mapGetListRequest(namespaceId, OnlyPerformerCurrentUser),
      )
        .then((resp) => {
          result.Value = mapGetListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getQueueList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список уровней сложности
   * @returns
   */
  getDifficultyList(nemespaceId?: string[]) {
    return new Promise<ResponseModel<Array<GetDifficultyListItem>>>(async (resolve) => {
      const result = new ResponseModel<Array<GetDifficultyListItem>>();

      await this.api.Main.TaskDifficultyListService.getDifficultyListAsync({
        NamespacesId: nemespaceId,
      })
        .then((resp) => {
          result.Value = mapGetDifficultyListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getDifficultyList', e);
          return resolve(result);
        });
    });
  }

  /**Получить список проектов */
  async GetProjects(
    request: ProjectSearchRequestModel,
  ): Promise<ResponseModel<BaseProjectSearchResponse>> {
    const result = new ResponseModel<BaseProjectSearchResponse>();
    try {
      const response = await this.api.Main.ProjectBaseService.searchAsync(request);
      result.Value = response;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      console.error('ERROR ProjectBaseService.Search', e);
    }
    return result;
  }

  /**
   * * Получение детальной информации о задаче
   * @param taskId ID задачи
   * @returns
   */
  getTaskDetail(taskId: number) {
    return new Promise<ResponseModel<TaskModelDetail>>(async (resolve) => {
      const result = new ResponseModel<TaskModelDetail>();

      await this.api.Main.ProjectTaskGetService.getByIdAsync(mapGetTaskDetailRequest(taskId))
        .then((resp) => {
          result.Value = mapGetTaskDetailResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTaskDetail', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение проекта по ID
   * @param projectId ID проекта
   * @returns
   */
  getProjectById(projectId: number) {
    return new Promise<ResponseModel<BaseProjectResponse>>(async (resolve) => {
      const result = new ResponseModel<BaseProjectResponse>();

      await this.api.Main.ProjectBaseService.getIdAsync({ ProjectId: projectId })
        .then((resp) => {
          result.Value = new BaseProjectResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getProjectById', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение рабочей области по ID
   * @param namespaceId ID рабочей области
   * @returns
   */
  getNamespaceById(namespaceId: string) {
    return new Promise<ResponseModel<GetNamespaceByIdResponse>>(async (resolve) => {
      const result = new ResponseModel<GetNamespaceByIdResponse>();

      await this.api.Main.ProjectNamespaceService.getNamespaceByIdAsync({
        NamespaceId: namespaceId,
      })
        .then((resp) => {
          result.Value = new GetNamespaceByIdResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaceById', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение очереди по ID
   * @param namespaceId ID очереди
   * @returns
   */
  getQueueById(queueId: string) {
    return new Promise<ResponseModel<ProjectQueueTaskListItem>>(async (resolve) => {
      const result = new ResponseModel<ProjectQueueTaskListItem>();

      await this.api.Main.ProjectQueueTaskService.getListAsync({
        Search: '',
        QueueTaskId: queueId,
        NamespacesId: [],
        OnlyPerformerCurrentUser: false,
        Page: { Skip: 0, Take: 1000 },
      })

        .then((resp) => {
          const queue = resp.Items.find((item) => item.Id === queueId);
          result.Value = new ProjectQueueTaskListItem(queue);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getQueueById', e);
          return resolve(result);
        });
    });
  }

  getTaskListByTreeShortAsync(request: GetTaskListByTreeShortRequest) {
    return new Promise<PaginationResponseModel<TaskModel[]>>(async (resolve) => {
      const result = new PaginationResponseModel<TaskModel[]>();

      await this.api.Main.ProjectTaskGetService.getTaskListByTreeShortAsync(
        new GetTaskListByTreeShortRequest({
          GroupId: request.GroupId,
          NamespaceId: request.NamespaceId,
          ProjectId: request.ProjectId,
          Filter: request.Filter,
          Page: request.Page,
        }),
      )
        .then((resp) => {
          result.IsSuccess = true;
          result.Items = resp.Items.map(
            (task) =>
              new TaskModel({
                Id: task.Id,
                ProjectId: task.ProjectId,
                Difficulty: new DifficultyLevelTaskModel({
                  DifficultyId: task.Difficulty.DifficultyId,
                  DifficultyName: task.Difficulty.DifficultyName,
                  DifficultyColor: task.Difficulty.DifficultyColor,
                }),
                NamespaceInfo: task.QueueTaskList.map(
                  (item) =>
                    new QueueTaskNamespaceModel({
                      Name: item.Namespace.Name,
                      Id: item.Namespace.Id,
                      ColorId: item.Namespace.ColorId,
                      Color: item.Namespace.Color,
                      IconId: item.Namespace.IconId,
                      IconUrl: item.Namespace.IconUrl,
                    }),
                ),
                EstimateTime: task.EstimateTime,
                WorkTime: task.WorkTime,
                Name: task.Name,
                Author: new TaskPersonModel({
                  Id: task.Owner.Id,
                  FirstName: task.Owner.FirstName,
                  LastName: task.Owner.LastName,
                  MiddleName: task.Owner.MiddleName,
                  ImageUrl: task.Owner.Photo,
                  NoPhotoColor: task.Owner.AvatarColor,
                }),
                Status: new TaskStatusModel({
                  Id: task.Status?.StatusId,
                  Name: task.Status?.StatusName,
                  Color: task.Status?.StatusColor,
                }),
                Priority: new TaskPriorityModel({
                  Id: task.Priority?.PriorityId,
                  Name: task.Priority?.PriorityName,
                  Color: task.Priority?.PriorityColor,
                }),
                // QueueTaskList: task.QueueTaskList,
              }),
          );
          result.Count = resp.Page.Count;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по статусам
   * @param request
   * @returns
   */
  private getGroupedByStatusTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<GroupedTaskItemModel>>();

      await this.api.Main.ProjectTaskGetService.getGroupedByStatusTaskListAsync(
        mapGetGroupedByStatusTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByStatusTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByStatusTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по статусу
   * @param request
   * @returns
   */
  getByStatusTaskList(request: GetByStatusTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByStatusTaskListAsync(
        mapGetByStatusTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByStatusTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByStatusTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по приоритету
   * @param request
   * @returns
   */
  getByPriorityTaskList(request: GetByPriorityTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByPriorityTaskListAsync(
        mapGetByPriorityTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByPriorityTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByPriorityTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по исполнителю
   * @param request
   * @returns
   */
  getByPerformerTaskList(request: GetByPerformerTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByPerformerTaskListAsync(
        mapGetByPerformerTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByPerformerTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByPerformerTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по тегу
   * @param request
   * @returns
   */
  getByTagTaskList(request: GetByTagTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByTagTaskListAsync(
        mapGetByTagTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByTagTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByTagTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список тегов
   * @param projectId Id проекта
   * @returns
   */
  getTags(projectId: number) {
    return new Promise<ResponseModel<Array<TagModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<TagModel>>();

      await this.api.Main.TagGetService.getTagsByProjectIdAsync(mapGetTagsRequest(projectId))
        .then((resp) => {
          result.Value = mapGetTagsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTags', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по тегу
   * @param request
   * @returns
   */
  getByTypeTaskList(request: GetByTypeTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByTypeTaskListAsync(
        mapGetByTypeTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByTypeTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByTypeTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список типов
   * @param projectId Id проекта
   * @returns
   */
  getTypes(namespaceId: string) {
    return new Promise<ResponseModel<TypeModel[]>>(async (resolve) => {
      const result = new ResponseModel<TypeModel[]>();

      await this.api.Main.TaskTypeListService.getListTaskTypeAsync(
        new GetListTaskTypeRequest({ NamespaceId: namespaceId }),
      )
        .then((resp) => {
          result.Value = mapGetTypesResponse(resp);

          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTags', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач по создателю
   * @param request
   * @returns
   */
  getByOwnerTaskList(request: GetByOwnerTasksRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      let result = new PageResponseModel<TaskModel>();

      await this.api.Main.ProjectTaskGetService.getByOwnerTaskListAsync(
        mapGetByOwnerTaskListRequest(request),
      )
        .then((resp) => {
          result = mapGetByOwnerTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByOwnerTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по приоритетам
   * @param request
   * @returns
   */
  private getGroupedByPriorityTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<GroupedTaskItemModel>>();

      await this.api.Main.ProjectTaskGetService.getGroupedByPriorityTaskListAsync(
        mapGetGroupedByPriorityTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByPriorityTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByPriorityTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по исполнителям
   * @param request
   * @returns
   */
  private getGroupedByPerformerTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<GroupedTaskItemModel>>();

      await this.api.Main.ProjectTaskGetService.getGroupedByPerformerTaskListAsync(
        mapGetGroupedByPerformerTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByPerformerTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByPerformerTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по создателям
   * @param request
   * @returns
   */
  private getGroupedByOwnerTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<GroupedTaskItemModel>>();

      await this.api.Main.ProjectTaskGetService.getGroupedByOwnerTaskListAsync(
        mapGetGroupedByOwnerTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByOwnerTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByOwnerTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по тегам
   * @param request
   * @returns
   */
  private getGroupedByTagTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<GroupedTaskItemModel>>();

      await this.api.Main.ProjectTaskGetService.getGroupedByTagTaskListAsync(
        mapGetGroupedByTagTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByTagTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByTagTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач по типу
   * @param request
   * @returns
   */
  private getGroupedByTypeTaskList(request: GroupedTaskRequestModel) {
    const result = new ResponseModel<Array<GroupedTaskItemModel>>();

    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      await this.api.Main.ProjectTaskGetService.getGroupedByTypeTaskListAsync(
        mapGetGroupedByTypeTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetGroupedByTypeTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getGroupedByTypeTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение задач без группировки
   * @param request
   * @returns
   */
  private getWithoutGroupingTaskList(request: GroupedTaskRequestModel) {
    const result = new ResponseModel<Array<GroupedTaskItemModel>>();
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      await this.api.Main.ProjectTaskGetService.getWithoutGroupingTaskListAsync(
        mapGetWithoutGroupingTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetWithoutGroupingTaskListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getWithoutGroupingTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение сгруппированных задач
   * @param request
   * @returns
   */
  async getGroupedTaskList(request: GroupedTaskRequestModel) {
    return new Promise<ResponseModel<Array<GroupedTaskItemModel>>>(async (resolve) => {
      switch (request.GrouppedBy) {
        case TasksKanbanGrouppingTypeEnum.Status:
          return resolve(this.getGroupedByStatusTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Priority:
          return resolve(this.getGroupedByPriorityTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Performer:
          return resolve(this.getGroupedByPerformerTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Author:
          return resolve(this.getGroupedByOwnerTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Tag:
          return resolve(this.getGroupedByTagTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Type:
          return resolve(this.getGroupedByTypeTaskList(request));
        case TasksKanbanGrouppingTypeEnum.None:
          return resolve(this.getWithoutGroupingTaskList(request));
      }
    });
  }

  // /**
  //  * * Получение задач
  //  * @param request
  //  * @returns
  //  */
  async getTaskList(_request: GroupedTaskRequestModel) {
    return new Promise<PageResponseModel<TaskModel>>(async (resolve) => {
      const request = {
        QueueTaskId: _request.QueueTaskId,
        ViewSettings: _request.ViewSettings,
        Sort: _request.Sort,
        Page: new PageRequestModel({
          Skip: _request.Page.Skip,
          Take: _request.Page.Take,
        }),
      } as any;
      switch (_request.GrouppedBy) {
        case TasksKanbanGrouppingTypeEnum.Status:
          request.StatusId = _request.ParameterId;
          return resolve(this.getByStatusTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Priority:
          request.PriorityId = _request.ParameterId;
          return resolve(this.getByPriorityTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Performer:
          request.PerformerId = _request.ParameterId;
          return resolve(this.getByPerformerTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Author:
          request.OwnerId = _request.ParameterId;
          return resolve(this.getByOwnerTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Tag:
          request.TagId = _request.ParameterId;
          return resolve(this.getByTagTaskList(request));
        case TasksKanbanGrouppingTypeEnum.Type:
          request.TypeId = _request.ParameterId;
          return resolve(this.getByTypeTaskList(request));
      }
    });
  }

  /**
   * * Получение подзадач
   * @param request
   * @returns
   */
  getByParentTaskList(request: GetByParentTasksRequestModel) {
    return new Promise<ResponseModel<Array<TaskModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<TaskModel>>();

      await this.api.Main.ProjectTaskGetService.getByParentTaskListAsync(
        mapGetByParentTaskListRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetByParentTaskListResponse(resp, request.ParentId);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getByParentTaskList', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Обновить приоритет задачи
   * @param request
   * @returns
   */
  updatePriority(request: TaskUpdatePriorityModel) {
    return new Promise<ResponseModel>(async (resolve) => {
      const result = new ResponseModel();

      await this.api.Main.ProjectTaskSaveService.updatePriorityAsync(
        mapUpdatePriorityRequest(request),
      )
        .then((resp) => {
          result.IsSuccess = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR updatePriority', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Обновить статус задачи
   * @param request
   * @returns
   */
  updateStatus(request: TaskUpdateStatusModel) {
    return new Promise<ResponseModel>(async (resolve) => {
      const result = new ResponseModel();

      await this.api.Main.ProjectTaskSaveService.updateStatusAsync(mapUpdateStatusRequest(request))
        .then((resp) => {
          result.IsSuccess = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR updateStatus', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Обновить тип задачи
   * @param request
   * @returns
   */
  updateTaskType(request: TaskUpdateTypeModel) {
    return new Promise<ResponseModel>(async (resolve) => {
      const result = new ResponseModel();
      await this.api.Main.ProjectTaskSaveService.updateTaskTypeAsync(mapUpdateTypeRequest(request))
        .then((resp) => {
          result.IsSuccess = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR updateTaskType', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Прикрепить подзадачу
   */
  attachSubtask(taskId: number, parentId: number) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.ProjectTaskSaveService.attachSubtaskAsync(
        new AttachSubtaskRequest({
          TaskId: taskId,
          ParentId: parentId,
        }),
      )
        .then((resp) => {
          result.Value = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR attachSubtask', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Убрать подзадачу из задачи
   * @param subtaskId ID подазадчи
   * @returns
   */
  removeSubtask(subtaskId: number) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.ProjectTaskSaveService.removeSubtaskAsync(
        new RemoveSubtaskRequest({
          SubtaskId: subtaskId,
        }),
      )
        .then((resp) => {
          result.Value = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR removeSubtask', e);
          return resolve(result);
        });
    });
  }

  OnUpdateQueueTaskStatus(response: any) {
    this.UpdateQueueTaskStatusEvent.trigger(response);
  }

  // OnUpdateQueueTaskPriority(response: any) {
  //   this.UpdateQueueTaskPriorityEvent.trigger(response);
  // }

  // OnUpdateProjectTags(response: any) {
  //   this.UpdateProjectTagsEvent.trigger(response);
  // }

  // OnUpsertTypeToNamespaceId(response: any) {
  //   this.UpsertTypeToNamespaceIdEvent.trigger(response);
  // }

  // OnUpsertDifficultyToNamespaceId(response: any) {
  //   this.UpsertDifficultyToNamespaceIdEvent.trigger(response);
  // }

  ToggleSubscribe(isSubscribe: boolean) {
    const func: keyof Events<any> = isSubscribe ? 'on' : 'removeListener';
    this.api.Main.TaskStatusSaveService.UpdateQueueTaskStatusEvent[func](
      this.OnUpdateQueueTaskStatus.bind(this),
    );
    // this.api.Main.TaskPrioritySaveService.UpdateQueueTaskPriorityEvent.on(this.OnUpdateQueueTaskPriority.bind(this));
    // this.api.Main.TagSaveService.UpdateProjectTagsEvent.on(this.OnUpdateProjectTags.bind(this));
    // this.api.Main.TaskTypeSaveService.UpsertTypeToNamespaceIdEvent.on(this.OnUpsertTypeToNamespaceId.bind(this));
    // this.api.Main.TaskDifficultySaveService.UpsertDifficultyToNamespaceIdEvent.on(this.OnUpsertDifficultyToNamespaceId.bind(this));
  }
  /**Отправка уведомления об ошибке */
  sendErrorNotification(message: string) {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: message,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
}
